module.exports = __webpack_public_path__ + "static/media/card-publique-sua-obra.315a6e1a.png";